import { render, staticRenderFns } from "./document-icon.vue?vue&type=template&id=c0000706&scoped=true"
import script from "./document-icon.vue?vue&type=script&lang=js"
export * from "./document-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0000706",
  null
  
)

export default component.exports